// const productData = [
//   {
//     id: 1,
//     categoryId: 1,
//     title: "Fishing Net",
//     subtitle: "Agriculture Net",
//     image: "/assets/images/shop/3.png",
//     images: ["/assets/images/shop/3.png", "/assets/images/shop/4.png"],
//     price: 19.99,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "Color : Blue",
//       "Size: 54” x 50 Meter",
//       "Weight: 2 KG To 3.5 KG",
//       "Raw-Materials: High-Density Polyethylene yarn",
//     ],
//     tags: ["Agriculture Net", "Fishing Net", "HDPE", "Blue"],
//     link: "/products/fishing-net",
//   },

//   {
//     id: 3,
//     categoryId: 1,
//     title: "Fishing Net",
//     subtitle: "Agriculture Net",
//     image: "/assets/images/shop/5.png",
//     price: 19.99,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "Color : Blue",
//       "Size: 54” x 50 Meter",
//       "Weight: 2 KG To 3.5 KG",
//       "Raw-Materials: High-Density Polyethylene yarn",
//     ],
//     tags: ["Agriculture Net", "Fishing Net", "HDPE", "Blue"],
//     link: "/products/fishing-net",
//   },

//   {
//     id: 4,
//     categoryId: 1,
//     title: "Fishing Net",
//     subtitle: "Agriculture Net",
//     image: "/assets/images/shop/6.png",
//     images: ["/assets/images/shop/6.png", "/assets/images/shop/7.png"],
//     price: 19.99,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "Color : Blue",
//       "Size: 54” x 50 Meter",
//       "Weight: 2 KG To 3.5 KG",
//       "Raw-Materials: High-Density Polyethylene yarn",
//     ],
//     tags: ["Agriculture Net", "Fishing Net", "HDPE", "Blue"],
//     link: "/products/fishing-net",
//   },

//   {
//     id: 6,
//     categoryId: 1,
//     title: "Fishing Net",
//     subtitle: "Agriculture Net",
//     image: "/assets/images/shop/8.png",
//     images: ["/assets/images/shop/8.png", "/assets/images/shop/9.png"],
//     price: 19.99,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "Color : Blue",
//       "Size: 54” x 50 Meter",
//       "Weight: 2 KG To 3.5 KG",
//       "Raw-Materials: High-Density Polyethylene yarn",
//     ],
//     tags: ["Agriculture Net", "Fishing Net", "HDPE", "Blue"],
//     link: "/products/fishing-net",
//   },

//   {
//     id: 8,
//     categoryId: 2,
//     title: "Poly Bag",
//     subtitle: "Garments Accessories",
//     image: "/assets/images/shop/11.png",
//     price: 5.05,
//     discountPrice: null,
//     sale: false,
//     rating: 4,
//     reviewCount: 8,
//     description: [
//       "Material: HDPE, PP, LDPE Poly Bag",
//       "Size: Any Type Of Size Produce",
//       "Print Poly: One Color To 6 Color",
//       "Thickness: 0.02mm To 0.20mm",
//     ],
//     tags: ["Poly Bag", "HDPE", "PP", "LDPE", "Garments Accessories"],
//     link: "/products/agro-net",
//   },

//   {
//     id: 9,
//     categoryId: 2,
//     title: "Gum Tap",
//     subtitle: "Garments Accessories",
//     image: "/assets/images/shop/1.png",
//     images: ["/assets/images/shop/1.png", "/assets/images/shop/2.png"],
//     price: 5.0,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "Size: 0.5 Inch To 3 Inch",
//       "Yards: 50 To 300 Yards",
//       "Color: Yellowish & Transparent",
//     ],
//     tags: ["Gum Tap", "Garments Accessories", "Yellowish", "Transparent"],
//     link: "/products/mosquito-net",
//   },

//   {
//     id: 11,
//     categoryId: 2,
//     title: "Hanger",
//     subtitle: "Garments Accessories",
//     image: "/assets/images/shop/12.png",
//     images: ["/assets/images/shop/12.png", "/assets/images/shop/13.png"],
//     price: 9.05,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "Model: 470",
//       "Weight: 34 Gm",
//       "Color: Black",
//       "Raw-Materials: Polypropylene Injection Molding",
//     ],
//     tags: [
//       "Hanger",
//       "Polypropylene",
//       "Injection Molding",
//       "Garments Accessories",
//     ],
//     link: "/products/building-safety-net",
//   },

//   {
//     id: 13,
//     categoryId: 2,
//     title: "Poly Hanger",
//     subtitle: "Garments Accessories",
//     image: "/assets/images/shop/10.png",
//     price: 19.99,
//     discountPrice: null,
//     sale: false,
//     rating: 4,
//     reviewCount: 8,
//     description: [
//       "Model: 470",
//       "Weight: 34 Gm",
//       "Color: Black",
//       "Raw-Materials: Polypropylene Injection Molding",
//     ],
//     tags: ["Poly Hanger", "Polypropylene", "Garments Accessories"],
//     link: "/products/garments-accessories",
//   },

//   {
//     id: 14,
//     categoryId: 3,
//     title: "Poultry Net",
//     subtitle: "Agriculture Net",
//     image: "/assets/images/shop/shop-thumb-07.png",
//     images: [
//       "/assets/images/shop/shop-thumb-07.png",
//       "/assets/images/shop/details/shop-details-01.png",
//       "/assets/images/shop/details/shop-details-02.png",
//       "/assets/images/shop/details/shop-details-03.png",
//       "/assets/images/shop/details/shop-details-04.png",
//     ],
//     price: 19.99,
//     discountPrice: null,
//     sale: false,
//     rating: 5,
//     reviewCount: 6,
//     description: [
//       "High-quality poultry net suitable for agricultural and poultry applications.",
//     ],
//     tags: ["Poultry Net", "Agriculture", "Net"],
//     link: "/products/poultry-net",
//   },
// ];

// export default productData;

const productData = [
  {
    id: 1,
    categoryId: 1,
    title: "Fishing Net",
    subtitle: "Agriculture Net",
    image: "/assets/images/shop/3.png",
    description: [
      "Color : Blue",
      "Size: 54” x 50 Meter",
      "Weight: 2 KG To 3.5 KG",
      "Raw-Materials: High-Density Polyethylene yarn",
    ],
  },

  {
    id: 2,
    categoryId: 1,
    title: "Fishing Net",
    subtitle: "Agriculture Net",
    image: "/assets/images/shop/5.png",
    description: [
      "Color : Blue",
      "Size: 54” x 50 Meter",
      "Weight: 2 KG To 3.5 KG",
      "Raw-Materials: High-Density Polyethylene yarn",
    ],
  },

  {
    id: 3,
    categoryId: 1,
    title: "Fishing Net",
    subtitle: "Agriculture Net",
    image: "/assets/images/shop/6.png",
    detailsimage1: "/assets/images/shop/7.png",
    description: [
      "Color : Blue",
      "Size: 54” x 50 Meter",
      "Weight: 2 KG To 3.5 KG",
      "Raw-Materials: High-Density Polyethylene yarn",
    ],
  },

  {
    id: 4,
    categoryId: 1,
    title: "Fishing Net",
    subtitle: "Agriculture Net",
    image: "/assets/images/shop/8.png",
    detailsimage1: "/assets/images/shop/9.png",
    description: [
      "Color : Blue",
      "Size: 54” x 50 Meter",
      "Weight: 2 KG To 3.5 KG",
      "Raw-Materials: High-Density Polyethylene yarn",
    ],
  },

  {
    id: 5,
    categoryId: 2,
    title: "Poly Bag",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/11.png",
    description: [
      "Material: HDPE, PP, LDPE Poly Bag",
      "Size: Any Type Of Size Produce",
      "Print Poly: One Color To 6 Color",
      "Thickness: 0.02mm To 0.20mm",
    ],
  },

  {
    id: 6,
    categoryId: 2,
    title: "Gum Tap",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/1.png",
    detailsimage1: "/assets/images/shop/2.png",
    description: [
      "Size: 0.5 Inch To 3 Inch",
      "Yards: 50 To 300 Yards",
      "Color: Yellowish & Transparent",
    ],
  },

  {
    id: 7,
    categoryId: 2,
    title: "Hanger",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/12.png",
    detailsimage1: "/assets/images/shop/13.png",
    description: [
      "Model: 470",
      "Weight: 34 Gm",
      "Color: Black",
      "Raw-Materials: Polypropylene Injection Molding",
    ],
  },

  {
    id: 8,
    categoryId: 2,
    title: "Poly Hanger",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/10.png",
    description: [
      "Model: 470",
      "Weight: 34 Gm",
      "Color: Black",
      "Raw-Materials: Polypropylene Injection Molding",
    ],
  },

  {
    id: 14,
    categoryId: 2,
    title: "HDPE YARN",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/14.png",
    detailsimage1: "/assets/images/shop/15.png",
    description: [
      "Thickness : 0.11mm To 0.13mm",
      "Color : Yellow, Blue, White & Red",
      "Raw-Materials: High-Density Polyethylene yarn",
    ],
  },

  {
    id: 9,
    categoryId: 2,
    title: "Hanging Hook",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/16.png",
    description: [
      "PM-HOOK-0001",
      "Color :  White & Black",
      "Size: 48mm",
      "Weight: 0.57 GM",
      "Raw-Materials: Polypropylene Injection Molding",
    ],
  },

  {
    id: 10,
    categoryId: 2,
    title: "Hanging Hook",
    subtitle: "Garments Accessories",
    image: "/assets/images/shop/17.png",
    description: [
      "SM-Hook-HZ-Yz21-01",
      "Color: White & Black",
      "Weight: 2.24 GM",
      "Weight: 0.57 GM",
      "Raw-Materials: Polypropylene Injection Molding",
    ],
  },

  // {
  //   id: 14,
  //   categoryId: 3,
  //   title: "Poultry Net",
  //   subtitle: "Agriculture Net",

  //   image: "/assets/images/shop/shop-thumb-07.png",

  //   images: [
  //     "/assets/images/shop/shop-thumb-07.png",
  //     "/assets/images/shop/details/shop-details-01.png",
  //     "/assets/images/shop/details/shop-details-02.png",
  //     "/assets/images/shop/details/shop-details-03.png",
  //     "/assets/images/shop/details/shop-details-04.png",
  //   ],

  //   price: 19.99,
  //   discountPrice: null,
  //   sale: false,
  //   rating: 5,
  //   reviewCount: 6,

  //   description: [
  //     "High-quality poultry net suitable for agricultural and poultry applications.",
  //   ],

  //   tags: ["Poultry Net", "Agriculture", "Net"],

  //   link: "/products/poultry-net",
  // },
];

export default productData;
